module.exports = __webpack_public_path__ + "media/images/smart_phone/products/cup_noodle1-fd1f5ef1a5e027c8eaa46f1e60550222.jpeg";